var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20501 3.23501C5.06846 3.37957 4.99492 3.57245 5.00054 3.77122C5.00617 3.97 5.09051 4.1584 5.23501 4.29501L9.15801 8.00001L5.23501 11.705C5.0953 11.8427 5.0151 12.0297 5.01162 12.2258C5.00814 12.422 5.08164 12.6117 5.21638 12.7543C5.35112 12.8968 5.53635 12.981 5.73238 12.9886C5.92841 12.9962 6.11961 12.9267 6.26501 12.795L10.765 8.54501C10.8392 8.47491 10.8982 8.39042 10.9386 8.29671C10.9789 8.203 10.9998 8.10204 10.9998 8.00001C10.9998 7.89797 10.9789 7.79701 10.9386 7.7033C10.8982 7.60959 10.8392 7.52511 10.765 7.45501L6.26501 3.20501C6.12045 3.06846 5.92757 2.99492 5.7288 3.00054C5.53002 3.00617 5.34162 3.09051 5.20501 3.23501Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.84da634f50d3c33b7227703c38c9a282.svg";
export { ForwardRef as ReactComponent };